import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_Payouts = _resolveComponent("Payouts")!
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_Transactions = _resolveComponent("Transactions")!
  const _component_RevShare = _resolveComponent("RevShare")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, { class: "dashboard__page" }, {
    default: _withCtx(() => [
      _createVNode(_component_q_tabs, {
        dense: "",
        modelValue: _ctx.paymentsTab,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.paymentsTab) = $event)),
        "inline-label": "",
        breakpoint: 0,
        align: "justify",
        style: {"background-color":"#252c3e","margin-bottom":"25px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_tab, {
            "no-caps": "",
            name: "payouts",
            label: _ctx.$t('pages.payments.tabPayment')
          }, null, 8, ["label"]),
          _createVNode(_component_q_tab, {
            "no-caps": "",
            name: "transactions",
            label: _ctx.$t('pages.payments.tabHistory')
          }, null, 8, ["label"]),
          _createVNode(_component_q_tab, {
            "no-caps": "",
            name: "revshare",
            label: _ctx.$t('pages.payments.tabRevShare')
          }, null, 8, ["label"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_q_tab_panels, {
        modelValue: _ctx.paymentsTab,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.paymentsTab) = $event)),
        animated: "",
        class: "bg-transparent"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_tab_panel, {
            name: "payouts",
            class: "q-mx-none"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Payouts)
            ]),
            _: 1
          }),
          _createVNode(_component_q_tab_panel, {
            name: "transactions",
            class: "q-mx-none"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Transactions)
            ]),
            _: 1
          }),
          _createVNode(_component_q_tab_panel, {
            name: "revshare",
            class: "q-mx-none"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_RevShare)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}